export const FLIGHT_INGREDIENT_SUFFIX = 'fl';
